import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { FiPhone, FiBriefcase } from 'react-icons/fi';
import { HiOutlineBuildingOffice2 } from 'react-icons/hi2';
import { useAuth } from '../../context/AuthContext';
import { authAPI } from '../../services/api';
import Logo from '../../components/Logo/Logo';
import toast from 'react-hot-toast';
import '../Register/Register.css';

const CompleteProfile = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { user } = useAuth();
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    phone: '',
    institution: '',
    occupation: ''
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!formData.phone && !formData.institution && !formData.occupation) {
      toast.error('Por favor completa al menos un campo');
      return;
    }

    try {
      setLoading(true);
      await authAPI.completeProfile(formData);
      toast.success('Perfil completado exitosamente');
      navigate('/');
    } catch (error) {
      console.error('Complete profile error:', error);
      toast.error(error.response?.data?.message || 'Error al completar el perfil');
    } finally {
      setLoading(false);
    }
  };

  const handleSkip = () => {
    navigate('/');
  };

  return (
    <div className="auth-page register-page">
      <div className="auth-container register-container">
        <div className="auth-card register-card">
          <div className="auth-header">
            <Logo size="large" showText={true} />
            <h1 className="auth-title">Completa tu Perfil</h1>
            <p className="auth-subtitle">
              Ayúdanos a conocerte mejor. Estos campos son opcionales pero nos ayudan a personalizar tu experiencia.
            </p>
          </div>

          <form onSubmit={handleSubmit} className="auth-form register-form">
            {/* Teléfono */}
            <div className="form-group">
              <label className="form-label">Teléfono (Opcional)</label>
              <div className="input-wrapper">
                <span className="input-icon-wrapper">
                  <FiPhone className="input-icon" />
                </span>
                <input
                  type="tel"
                  name="phone"
                  className="form-input"
                  placeholder="+57 300 123 4567"
                  value={formData.phone}
                  onChange={handleChange}
                />
              </div>
            </div>

            {/* Institución */}
            <div className="form-group">
              <label className="form-label">
                Institución / Organización (Opcional)
              </label>
              <div className="input-wrapper">
                <span className="input-icon-wrapper">
                  <HiOutlineBuildingOffice2 className="input-icon" />
                </span>
                <input
                  type="text"
                  name="institution"
                  className="form-input"
                  placeholder="Universidad, Empresa, etc."
                  value={formData.institution}
                  onChange={handleChange}
                />
              </div>
            </div>

            {/* Ocupación */}
            <div className="form-group">
              <label className="form-label">Ocupación (Opcional)</label>
              <div className="input-wrapper">
                <span className="input-icon-wrapper">
                  <FiBriefcase className="input-icon" />
                </span>
                <input
                  type="text"
                  name="occupation"
                  className="form-input"
                  placeholder="Estudiante, Ingeniero, Profesor, etc."
                  value={formData.occupation}
                  onChange={handleChange}
                />
              </div>
            </div>

            <div className="button-group">
              <button
                type="submit"
                className="submit-button primary-button"
                disabled={loading}
              >
                {loading ? 'Guardando...' : 'Completar Perfil'}
              </button>
              
              <button
                type="button"
                onClick={handleSkip}
                className="submit-button secondary-button"
                disabled={loading}
              >
                Omitir por ahora
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default CompleteProfile;
